import { httpClient } from '@/lib/httpClient';

export interface FileDto {
  id: string;
}

export interface StatusDto {
  id: number;
}

export enum StatusEnum {
  Active = 1,
  Inactive = 2,
}

export interface RoleDto {
  id: number;
}

export enum RoleEnum {
  Root = 1,
  User = 2,
  Admin = 3,
}

export interface CustomerDto {
  id: number;
  name: string;
}

export interface CreateUserDto {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  photo?: FileDto;
  role?: RoleDto;
  status?: StatusDto;
  customer?: { id: number };
}

export interface UpdateUserDto {
  email?: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  photo?: FileDto;
  role?: RoleDto;
  status?: StatusDto;
  customer?: { id: number };
}

export interface CreateUserResponse {
  created: boolean;
}

export interface User {
  id: number;
  email: string;
  provider: string;
  socialId: string;
  firstName: string;
  lastName: string;
  photo: {
    id: string;
    path: string;
  };
  role: {
    id: RoleEnum.User | RoleEnum.Admin;
    name: string;
  };
  status: {
    id: StatusEnum.Active | StatusEnum.Inactive;
    name: string;
  };
  customer: Partial<CustomerDto>;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
}

export interface SearchParams {
  page?: number;
  limit?: number;
  filterBy?: 'userId' | 'name' | 'email' | 'customerId';
  searchValue?: string;
}

export interface SearchUserResponse {
  totalItems: number;
  totalPages: number;
  currentPage: number;
  items: User[];
}

class UserService {
  constructor() {}
  async createUser(createUserDto: CreateUserDto) {
    const { data } = await httpClient.post<CreateUserDto>(
      `/v1/users`,
      createUserDto,
    );
    return data;
  }

  async getUserById(id: number) {
    const { data } = await httpClient.get<User>(`/v1/users/${id}`);
    return data;
  }

  async updateUser(id: number, updateUserDto: UpdateUserDto) {
    const { data } = await httpClient.patch<User>(
      `/v1/users/${id}`,
      updateUserDto,
    );
    return data;
  }

  async search(searchParams: SearchParams) {
    const { page = 1, limit = 10, filterBy, searchValue } = searchParams;

    let filters: Record<string, string> = {};

    if (filterBy && searchValue) {
      filters = {
        [filterBy]: searchValue,
      };
    }

    const { data } = await httpClient.get<SearchUserResponse>(
      '/v1/users/search',
      {
        params: {
          ...filters,
          page,
          limit,
        },
      },
    );
    return data;
  }
}

export default new UserService();
